import ArtWork from './ArtWork';

export default ArtWork;
